import { withCompInfo } from '@wix/editor-elements-integrations'
import { MenuContainerCSS, MenuContainerDefinition } from './MenuContainer'
import { CompInfo } from '@wix/thunderbolt-components-native'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import type { ClassicComponentLayout, FixedPositionItemLayout, SingleLayoutData } from '@wix/thunderbolt-becky-types'
import { sizeToString } from '@wix/thunderbolt-becky-root'

interface GetNonResponsiveCssProps {
	compLayout: CompInfo['compLayout']
	compSingleLayout?: SingleLayoutData
	siteWidth: number
	fillLayersCSSVars: any
}

const isHorizontallyStretched = (compLayout: CompInfo['compLayout'], compSingleLayout?: SingleLayoutData) => {
	const componentLayout = compSingleLayout?.componentLayout as ClassicComponentLayout
	if (!compSingleLayout) {
		return compLayout.docked?.left && compLayout.docked?.right
	}

	return componentLayout.width?.type === 'percentage' && componentLayout.width?.value === 100
}

const getMarginFromSingleLayoutData = (compSingleLayout: SingleLayoutData, side: 'left' | 'right') => {
	const itemLayout = compSingleLayout.itemLayout as FixedPositionItemLayout
	return sizeToString(itemLayout[side])
}

const getNonResponsiveCss = ({
	compLayout,
	compSingleLayout,
	siteWidth,
	fillLayersCSSVars,
}: GetNonResponsiveCssProps) => {
	const horizontallyStretched = isHorizontallyStretched(compLayout, compSingleLayout)
	const docked = compLayout.docked
	const rightMargin = compSingleLayout ? getMarginFromSingleLayoutData(compSingleLayout, 'right') : docked?.right
	const leftMargin = compSingleLayout ? getMarginFromSingleLayoutData(compSingleLayout, 'left') : docked?.left

	const position = `calc((100% - ${siteWidth}px) / 2)`

	const horizontallyDockedAndNotStretchedCss =
		(!horizontallyStretched &&
			rightMargin && {
				right: compSingleLayout ? rightMargin : position,
			}) ||
		(leftMargin && {
			left: compSingleLayout ? rightMargin : position,
		})

	return { ...horizontallyDockedAndNotStretchedCss, ...fillLayersCSSVars }
}

export const css = withCompInfo<MenuContainerCSS, MenuContainerDefinition>()(
	[
		'hasResponsiveLayout',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compLayout',
		'compSingleLayout',
		'compId',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
	],
	({
		hasResponsiveLayout,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compLayout,
		compSingleLayout,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		siteWidth,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
		// @ts-ignore - Remove once siteWidth is added to the compInfo
	}) => {
		const backgroundMedia = compDesign?.background || {}
		const fillLayersCSSVars = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compDesign,
			compProps,
			compId,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})
		return hasResponsiveLayout
			? {}
			: getNonResponsiveCss({
					compLayout,
					compSingleLayout,
					siteWidth,
					fillLayersCSSVars,
			  })
	}
)
